import {
    Suspense
} from 'react';
import { Router as ReactRouter } from 'react-router';

import Meta from 'Component/Meta';
import history from 'Util/History';

export const mapStateToProps = (args, callback) => {
    const [state] = args;

    return {
        ...callback(...args),
        matomo: state.MatomoReducer.matomo
    };
};
export const containerProps = (args, callback, instance) => {
    const {
        matomo
    } = instance.props;

    return {
        ...callback(...args),
        matomo
    };
};
const render = (args, callback, instance) => {
    const { matomo } = instance.props;

    if (!matomo.connectToHistory) {
        return callback(...args);
    }

    return (
        <>
            <Meta />
            <Suspense fallback={ instance.renderFallbackPage() }>
                <ReactRouter history={ matomo.connectToHistory(history) }>
                    { instance.renderRouterContent() }
                </ReactRouter>
            </Suspense>
        </>
    );
};

export default {
    'Component/Router/Container/mapStateToProps': {
        function: mapStateToProps
    },
    'Component/Router/Container': {
        'member-function': {
            containerProps
        }
    },
    'Component/Router/Component': {
        'member-function': {
            render
        }
    }
};
